


























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class NumPad extends Vue {
  @Prop(Number) readonly value!: number;
  output = this.value.toString();

  inputNum(event: MouseEvent) {
    const button = (event.target as HTMLButtonElement);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const input = button.textContent!;
    if (this.output.length === 4) { return; }
    if (this.output === '0') {
      if ('0123456789'.indexOf(input) >= 0) {
        this.output = input;
      } else {
        this.output += input;
      }
      return;
    }
    if (this.output.indexOf('.') >= 0 && input === '.') {
      return;
    }
    this.output += input;
  }

  remove() {
    if (this.output.length === 1) {
      this.output = '0';
    } else {
      this.output = this.output.slice(0, -1)
      ;
    }
  }

  empty() {
    this.output = '0';
  }

  ok() {
    this.$emit('update:value', parseFloat(this.output));
    this.$emit('submit', this.output);
  }

}
